import { registerComponent, scrollLock, triggerEvent } from "helpers";

function replaceElementTag(element, tagName) {
  const replacement = document.createElement(tagName);

  for (const attribute of [...element.attributes]) {
    replacement.setAttribute(attribute.name, attribute.value);
  }

  replacement.append(...element.childNodes);
  element.replaceWith(replacement);
}

registerComponent(
  "wyatt-modal",
  class WyattModal extends HTMLElement {
    constructor() {
      super();

      this.openButton = this.querySelector("[data-modal-open]");
      this.dialog = this.getModal();
      this.wrapper = this.dialog.querySelector("[data-modal-wrapper]");

      this.openButton.addEventListener("click", this.open.bind(this));

      this.handleClickOutside();

      this.dialog.addEventListener("close", this.close.bind(this));
    }

    connectedCallback() {
      document.querySelector("body").append(this.dialog);

      if (!this.dialog.open) {
        this.unmountModalHeadings();
      }
    }

    disconnectedCallback() {
      this.dialog.remove();
    }

    open() {
      this.mountModalHeadings();
      this.dialog.showModal();
      scrollLock.enable();
      triggerEvent(this.dialog, "modalOpen");
    }

    close() {
      this.unmountModalHeadings();
      scrollLock.disable();
      triggerEvent(this.dialog, "modalClose");
    }

    mountModalHeadings() {
      this.dialog.querySelectorAll("[data-modal-heading]").forEach((element) => {
        const tagName = element.dataset.modalHeading;

        if (!tagName || element.tagName.toLowerCase() === tagName.toLowerCase()) return;

        replaceElementTag(element, tagName);
      });
    }

    unmountModalHeadings() {
      this.dialog.querySelectorAll("[data-modal-heading]").forEach((element) => {
        const tagName = element.dataset.modalHeading;

        if (!tagName || element.tagName.toLowerCase() !== tagName.toLowerCase()) return;

        replaceElementTag(element, element.dataset.modalHeadingPlaceholder || "div");
      });
    }

    handleClickOutside() {
      this.dialog.addEventListener("click", () => {
        this.dialog.close();
      });
      this.wrapper.addEventListener("click", (event) => {
        event.stopPropagation();
      });
    }

    getModal() {
      return (
        this.querySelector("[data-modal]") ||
        document.querySelector(this.openButton.dataset.modalOpen)
      );
    }
  }
);
